import styled, { css } from 'styled-components'

import { DASHBOARD_STYLED_CONSTS } from '@components/common'
import { mediaQueries } from '@fourthwall/components'

export const Recommendations = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.tablet} {
    gap: var(--space-500);
  }
`

export const SuggestionWrapper = styled.div`
  position: relative;
  left: -${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL}px;
  width: calc(100% + ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL * 2}px);

  & + & {
    margin-top: -1px;
  }

  ${mediaQueries.tablet} {
    position: static;
    width: auto;

    & + & {
      margin-top: 0;
    }
  }
`

export const ShowMoreRecommendationsButton = styled.div`
  margin-top: var(--space-300);

  ${mediaQueries.tablet} {
    margin-top: 0;
  }

  text-align: center;
`

export const MiniRecommendations = styled.div`
  margin-bottom: 20px;

  & > * + * {
    margin-top: 16px;
  }
`

export const Title = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--space-100);
  margin-top: var(--space-200);

  ${mediaQueries.tablet} {
    margin-top: 0;
  }
`

export const Spacing = styled.div<{ $space: '400' | '800' | '1200' }>`
  ${({ $space }) =>
    $space === '400' &&
    css`
      & > * + * {
        margin-top: var(--space-400);
      }
    `}

  ${({ $space }) =>
    $space === '800' &&
    css`
      & > * + * {
        margin-top: var(--space-800);
      }
    `}

  ${({ $space }) =>
    $space === '1200' &&
    css`
      & > * + * {
        margin-top: var(--space-1200);
      }
    `}

  & > [data-empty='true'],
  & > :empty {
    margin-top: 0;
  }

  & > [data-empty='true'] + *,
  & > :empty + * {
    margin-top: 0;
  }
`
